import React from "react";
import request from "../services/requestService";
import { DOWNLOAD_EXCEL_CONSTANTS } from "../constant";
import * as apiServices from "../services/apiServices";
import { debounce } from "lodash";
import { toast } from "react-toastify";
import {
  transformProjectListPayload,
  transformIssueListPayload
} from "../helper";
import { successToastStyle, errorToastStyle } from "../customToast";

export const getNodalOfficerExcelReportAction = params => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.NODAL_OFFICER._START
    });
    return request(apiServices.getDownloadNodalUserSummary(params))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.NODAL_OFFICER._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.NODAL_OFFICER._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.NODAL_OFFICER._FAILURE
        });
      });
  };
};

export const clearNodalOfficerExcelReportAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.NODAL_OFFICER._FAILURE
    });
  };
};

export const getDownloadWeeklyReportAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT._START
    });
    return request(apiServices.getDownloadWeeklyReportSummary())
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT._SUCCESS,
            payload: resp.data.data
          });
        } else {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT._FAILURE
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT._FAILURE
        });
      });
  };
};

export const clearWeeklyReportReportAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT._CLEAR
    });
  };
};

export const getDownloadUserDetails = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.USER_DETAIL_REPORT._START
    });
    return requestMethod(apiServices.getDownloadUserDetails())
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.USER_DETAIL_REPORT._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.USER_DETAIL_REPORT._FAILURE
              });
            }
          });
        }
      })
      .catch(err => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.USER_DETAIL_REPORT._FAILURE
        });
      });
  };
};

export const clearUserDetailsReportAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.USER_DETAIL_REPORT._CLEAR
    });
  };
};

export const getDownloadMinistryStateIssueReport = (
  requestMethod = request,
  id
) => {
  if (id !== null && id !== "") {
    return function(dispatch) {
      dispatch({
        type: DOWNLOAD_EXCEL_CONSTANTS.MINISTRY_STATE_ISSUE_REPORT._START
      });
      return requestMethod(apiServices.getDownloadMinistryStateIssueReport(id))
        .then(resp => {
          const {
            data: { data }
          } = resp;
          if (data) {
            dispatch({
              type:
                DOWNLOAD_EXCEL_CONSTANTS.MINISTRY_STATE_ISSUE_REPORT._SUCCESS,
              payload: data
            });
          } else {
            dispatch({
              type:
                DOWNLOAD_EXCEL_CONSTANTS.MINISTRY_STATE_ISSUE_REPORT._FAILURE
            });
          }
        })
        .catch(err => {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.MINISTRY_STATE_ISSUE_REPORT._FAILURE
          });
        });
    };
  } else {
    return () => {};
  }
};

export const clearMinistryStateIssueReportAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.MINISTRY_STATE_ISSUE_REPORT._CLEAR
    });
  };
};

export const getDownloadIssueWithCommentsReportsAction = (
  requestMethod = request,
  data
) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_COMMENT._START
    });
    return requestMethod(apiServices.getUrlDownloadIssuesWithComment(data))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_COMMENT._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_COMMENT._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_COMMENT._FAILURE
        });
      });
  };
};

export const clearIssueWithCommentAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_COMMENT._CLEAR
    });
  };
};

export const getDownloadDecisionReportsAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DECISSION._START
    });
    return requestMethod(apiServices.getUrlDownloadIssuesWithDecision())
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.DECISSION._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.DECISSION._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DECISSION._FAILURE
        });
      });
  };
};

export const clearDecissionAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DECISSION._CLEAR
    });
  };
};

export const getDownloadDashboardSummaryAction = (
  requestMethod = request,
  data
) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DASHBOARD_SUMMARY._START
    });
    return requestMethod(apiServices.downloadDashboardSummary(data))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.DASHBOARD_SUMMARY._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.DASHBOARD_SUMMARY._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DASHBOARD_SUMMARY._FAILURE
        });
      });
  };
};

export const clearDashboardSummaryAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DASHBOARD_SUMMARY._CLEAR
    });
  };
};

export const getDownloadIssueListAction = (requestMethod = request, data) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_LIST._START
    });
    return requestMethod(
      apiServices.downloadIssuesListReport(transformIssueListPayload(data))
    )
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_LIST._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_LIST._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_LIST._FAILURE
        });
      });
  };
};

export const getDownloadIssueBriefDocAction = (
  requestMethod = request,
  data
) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF._START
    });
    return requestMethod(
      apiServices.downloadIssuesBriefReport(transformIssueListPayload(data))
    )
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF._FAILURE
        });
      });
  };
};

export const clearIssueListDownloadAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_LIST._CLEAR
    });
  };
};

export const clearIssueBriefDownloadAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF._CLEAR
    });
  };
};

export const clearIssueBriefPdfDownloadAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF_PDF._CLEAR
    });
  };
};

export const getDownloadProjectListAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.PROJECT_LIST._START
    });
    return requestMethod(
      apiServices.downloadProjectListReport(transformProjectListPayload(params))
    )
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.PROJECT_LIST._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.PROJECT_LIST._FAILURE
              });
            }
          });
        }
      })
      .catch(error => {
        console.log("Error while fetching issue list - ", error.message);
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.PRPJECT_LIST._FAILURE
        });
      });
  };
};

export const getDownloadAgendaListAction = (
  requestMethod = request,
  params
) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_LIST._START
    });
    return requestMethod(apiServices.downloadAgendaListReport(params))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_LIST._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_LIST._FAILURE
              });
            }
          });
        }
      })
      .catch(error => {
        console.log("Error while fetching meeting list - ", error.message);
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_LIST._FAILURE
        });
      });
  };
};

export const getDownloadIssueBriefPDFAction = (
  requestMethod = request,
  data
) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF_PDF._START
    });
    return requestMethod(
      apiServices.downloadIssuesBriefPDFReport(transformIssueListPayload(data))
    )
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF_PDF._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF_PDF._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.ISSUE_BRIEF_PDF._FAILURE
        });
      });
  };
};

export const clearProjectListDownloadAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.PROJECT_LIST._CLEAR
    });
  };
};

export const clearAgendaListDownloadAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_LIST._CLEAR
    });
  };
};

export const getDownloadMisReportByTypeAction = (
  requestMethod = request,
  data,
  report
) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.MIS_REPORTS._START
    });
    return requestMethod(apiServices.downloadProjectSummary(report, data))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, data => {
            if (data && data.url) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.MIS_REPORTS._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.MIS_REPORTS._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.MIS_REPORTS._FAILURE
        });
      });
  };
};

export const clearMisDownloadByTypeAction = report => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.MIS_REPORTS._FAILURE
    });
  };
};

export const getDownloadAgendaAction = (requestMethod = request, meetingId) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_DOWNLOAD._START
    });
    return requestMethod(apiServices.getDownloadAgenda(meetingId))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_DOWNLOAD._SUCCESS,
            payload: resp.data.data
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_DOWNLOAD._FAILURE
        });
      });
  };
};

export const clearAgendaDownloadAction = report => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_DOWNLOAD._FAILURE
    });
  };
};

export const uploadDownloadAgendaAction = (
  requestMethod = request,
  meetingId,
  files
) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_UPLOAD._START
    });
    return requestMethod(apiServices.getUploadAgenda(meetingId, files))
      .then(resp => {
        const { status, message } = resp.data || {};
        status
          ? toast.success(
              <p className="toast-text-alignment">{message}</p>,
              successToastStyle
            )
          : toast.error(
              <p className="toast-text-alignment">{message}</p>,
              errorToastStyle
            );
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_UPLOAD._SUCCESS
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_REPORTS_UPLOAD._FAILURE
        });
      });
  };
};

export const uploadMeetingTableAction = (
  requestMethod = request,
  meetingType,
  files
) => {
  return requestMethod(apiServices.getUploadMeeting(meetingType, files))
    .then(response => {
      return response.data;
    })
    .catch(err => err);
};

export const getMeetingTableAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.getMeetingTablesData(params))
    .then(response => {
      return response.data;
    })
    .catch(err => err);
};

export const getDownloadMinistryState = (requestMethod = request, payload) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MINSTRY_STATE._START,
      payload: { id: payload.groupId }
    });
    return requestMethod(apiServices.getDownloadMinistryState(payload))
      .then(resp => {
        const { data } = resp.data || {};
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MINSTRY_STATE._SUCCESS,
          payload: {
            id: payload.groupId,
            url: data
          }
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MINSTRY_STATE._FAILURE
        });
      });
  };
};

export const clearDownloadMinistryStateAction = id => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MINSTRY_STATE._CLEAR,
      payload: { id }
    });
  };
};

export const clearDownloadMilestoneAudit = id => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MILESTONE_AUDIT._CLEAR
      // payload: { id }
    });
  };
};

export const getDownloadMilestoneAudit = (requestMethod = request, id) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MILESTONE_AUDIT._START
    });
    return requestMethod(apiServices.downloadMilestoneAudit(id))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data && resp.data.data.data, data => {
            if (data && data.url) {
              dispatch({
                type:
                  DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MILESTONE_AUDIT._SUCCESS,
                payload: data.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MILESTONE_AUDIT._FAILURE
              });
            }
          });
        }
      })
      .catch(error => {
        //console.log("Error while fetching issue list - ", error.message);
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_MILESTONE_AUDIT._FAILURE
        });
      });
  };
};

export const getDownloadProjectDetailAction = (
  requestMethod = request,
  param
) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_PROJECT_DETAIL_STATE._START,
      payload: param
    });
    return requestMethod(apiServices.getDownloadProjectDetail(param))
      .then(resp => {
        const { data } = resp.data || {};
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_PROJECT_DETAIL_STATE._SUCCESS,
          payload: {
            id: param.projectId,
            url: data
          }
        });
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_PROJECT_DETAIL_STATE._FAILURE
        });
      });
  };
};

export const clearDownloadProjectDetailAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_PROJECT_DETAIL_STATE._CLEAR
    });
  };
};

export const getDownloadUserManualListAction = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL_LIST._START
    });
    return requestMethod(apiServices.getUserManualList())
      .then(resp => {
        const { data } = resp.data || {};
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL_LIST._SUCCESS,
          payload: data
        });
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL_LIST._FAILURE
        });
      });
  };
};

export const getUploadUserManualAction = (requestMethod = request, data) => {
  return function(dispatch) {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL_LIST._START
    });
    return requestMethod(apiServices.uploadUserManual(data))
      .then(resp => {
        dispatch(getDownloadUserManualListAction());
        dispatch(getUserManualAction());
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL_LIST._FAILURE
        });
      });
  };
};

export const getUserManualAction = (requestMethod = request) => {
  return function(dispatch) {
    return requestMethod(apiServices.getUserManual())
      .then(resp => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.DOWNLOAD_USER_MANUAL._SUCCESS,
          payload: resp.data ? resp.data.data : null
        });
      })
      .catch(console.error);
  };
};

// Excel Downloads End
const debouncePromise = function(time, key, callback) {
  const callApi = debounce(async () => {
    const downLoadResp = await request(apiServices.downloadExcel({ key: key }));
    const { data, status } = downLoadResp.data;
    if (!status) {
      return debouncePromise(time + 500, key, callback);
    } else {
      typeof callback === "function" && callback(data);
    }
  }, time);
  callApi();
};

const debouncePromiseMis = function(time, key, callback) {
  const callApi = debounce(async () => {
    const downLoadResp = await request(
      apiServices.getMisissueSummaryFileDownload(key)
    );
    const { data, status } = downLoadResp.data;
    if (!status) {
      return debouncePromiseMis(time + 500, key, callback);
    } else {
      typeof callback === "function" && callback(downLoadResp.data, status);
    }
  }, time);
  callApi();
};

export const downloadWeeklyReportForStatePmg = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT_FOR_STATE_PMG._START
    });
    return request(apiServices._downloadWeeklyReportForStatePmg())
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT_FOR_STATE_PMG._SUCCESS,
            payload: resp.data.data
          });
        } else {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT_FOR_STATE_PMG._FAILURE
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT_FOR_STATE_PMG._FAILURE
        });
      });
  };
};

export const clearWeeklyReportForStatePmgAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.WEEKLY_REPORT_FOR_STATE_PMG._CLEAR
    });
  };
};

export const downloadAgendaMeetingPpt = meetingId => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT._START
    });
    return request(apiServices._downloadAgendaMeetingPpt(meetingId))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT._SUCCESS,
            payload: resp.data.data
          });
        } else {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT._FAILURE
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT._FAILURE
        });
      });
  };
};

export const downloadAgendaCabSecPpt = meetingId => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_CABSEC_PPT._START
    });
    return request(apiServices.downloadAgendaCabSecPpt(meetingId))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_CABSEC_PPT._SUCCESS,
            payload: resp.data.data
          });
        } else {
          dispatch({
            type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_CABSEC_PPT._FAILURE
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_CABSEC_PPT._FAILURE
        });
      });
  };
};

export const downloadAgendaMeetingPptv2PragatiFormat = meetingId => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT._START
    });
    return request(apiServices.downloadAgendaPragatiFormatPpt(meetingId))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          dispatch({
            type:
              DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT
                ._SUCCESS,
            payload: resp.data.data
          });
        } else {
          dispatch({
            type:
              DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT
                ._FAILURE
          });
        }
      })
      .catch(() => {
        dispatch({
          type:
            DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT
              ._FAILURE
        });
      });
  };
};

export const clearDownloadAgendaMeetingPptAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT._CLEAR
    });
  };
};

export const downloadAgendaMeetingPptv2 = (
  meetingId,
  preset = false,
  isWithComment = false
) => {
  return dispatch => {
    const CONSTANTS = isWithComment
      ? DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2
      : DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE;
    dispatch({
      type: CONSTANTS._START
    });
    return request(
      apiServices._downloadAgendaMeetingPptv2(meetingId, preset, isWithComment)
    )
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          dispatch({
            type: CONSTANTS._SUCCESS,
            payload: resp.data.data
          });
        } else {
          dispatch({
            type: CONSTANTS._FAILURE
          });
        }
      })
      .catch(() => {
        dispatch({
          type: CONSTANTS._FAILURE
        });
      });
  };
};

export const clearDownloadAgendaMeetingPptv2Action = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2._CLEAR
    });
  };
};

export const clearDownloadAgendaMeetingPptv2WithoutIssueAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_WITHOUT_ISSUE._CLEAR
    });
  };
};

export const clearDownloadAgendaMeetingPptv2PragatiFormatAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_PPT_V2_PRAGATI_FORMAT._CLEAR
    });
  };
};

export const clearDownloadAgendaMeetingCabSecPptAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_CABSEC_PPT._CLEAR
    });
  };
};

export const downloadAgendaMeetingExcel = meeting => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_EXCEL._START
    });
    return request(apiServices._downloadAgendaMeetingExcel(meeting))
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          debouncePromise(500, resp.data.data, meeting => {
            if (meeting) {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_EXCEL._SUCCESS,
                payload: meeting.url
              });
            } else {
              dispatch({
                type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_EXCEL._FAILURE
              });
            }
          });
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_EXCEL._FAILURE
        });
      });
  };
};

export const clearDownloadAgendaMeetingExcelAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.AGENDA_MEETING_EXCEL._CLEAR
    });
  };
};

export const downloadMarch24ReportExcelAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.MARCH24_REPORT._START
    });
    return request(apiServices._downloadMarch24ReportExcel())
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          if (resp.data.data) {
            dispatch({
              type: DOWNLOAD_EXCEL_CONSTANTS.MARCH24_REPORT._SUCCESS,
              payload: resp.data.data
            });
          } else {
            dispatch({
              type: DOWNLOAD_EXCEL_CONSTANTS.MARCH24_REPORT._FAILURE
            });
          }
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.MARCH24_REPORT._FAILURE
        });
      });
  };
};

export const clearDownloadMarch24ReportExcelAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.MARCH24_REPORT._CLEAR
    });
  };
};

export const downloadUpdaloadAgendaTemplateAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._START
    });
    return request(apiServices._downloadUploadAgendaTemplate())
      .then(resp => {
        if (resp.data && resp.data.status && resp.data.data) {
          if (resp.data.data) {
            dispatch({
              type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._SUCCESS,
              payload: resp.data.data
            });
          } else {
            dispatch({
              type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._FAILURE
            });
          }
        }
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._FAILURE
        });
      });
  };
};

// export const downloadUpdaloadAgendaTemplateAction = () => {
//   return (dispatch) => {
//     dispatch({ type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._START });

//     return request(apiServices._downloadUploadAgendaTemplate())
//       .then((res) => {
//         console.log('res', res);
//         console.log('Blob type:', res.data.type);
//         console.log('Blob size:', res.data.size);

//         // STEP 1: Detect JSON error inside blob
//         if (res.data.type && res.data.type.includes('application/json')) {
//           const reader = new FileReader();
//           reader.onload = () => {
//             const error = JSON.parse(reader.result);
//             toast.error(error.message || 'Download failed');
//           };
//           reader.readAsText(res.data);

//           dispatch({
//             type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._FAILURE,
//           });
//           return;
//         }

//         // STEP 2: Create excel blob
//         const blob = new Blob([res.data], {
//           type:
//             'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
//         });

//         const url = window.URL.createObjectURL(blob);
//         const a = document.createElement('a');
//         a.href = url;
//         a.download = 'Upload_Agenda_Template.xlsx';
//         a.click();
//         a.remove();
//         window.URL.revokeObjectURL(url);

//         dispatch({
//           type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._SUCCESS,
//         });
//       })
//       .catch(() => {
//         dispatch({
//           type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._FAILURE,
//         });
//       });
//   };
// };

export const clearDownloadUpdaloadAgendaTemplateAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_AGENDA_TMP._CLEAR
    });
  };
};

export const uploadProjectIssuesAction = files => {
  console.log("In uploadProjectIssuesAction");
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_PROJECT_ISSUES._START
    });
    return request(apiServices._uploadProjectIssues(files))
      .then(resp => {
        if (resp.data && resp.status) {
          if (resp.data) {
            dispatch({
              type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_PROJECT_ISSUES._SUCCESS,
              payload: resp.data
            });
            //return { success: true, data: resp.data.data };
          } else {
            dispatch({
              type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_PROJECT_ISSUES._FAILURE
            });
            // return { success: false };
          }
        }
        return resp;
      })
      .catch(() => {
        dispatch({
          type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_PROJECT_ISSUES._FAILURE
        });
        //return { success: false };
      });
  };
};

export const clearUploadProjectIssuesAction = () => {
  return dispatch => {
    dispatch({
      type: DOWNLOAD_EXCEL_CONSTANTS.UPLOAD_PROJECT_ISSUES._CLEAR
    });
  };
};
